const Style = {
  link: 'block text-blue-500',
};

export default Style;
